import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Truck, CheckCircle, Tag } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function HeroSection() {
  return <section className="relative w-full min-h-screen flex flex-col items-center justify-center bg-dark-900 px-4 py-20 overflow-hidden" data-id="element-87">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-88">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-gold-500/5 rounded-full blur-[100px]" data-id="element-89" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] bg-gold-500/5 rounded-full blur-[100px]" data-id="element-90" />
      </div>

      <div className="relative z-10 max-w-5xl w-full mx-auto text-center flex flex-col items-center" data-id="element-91">
        {/* Badges */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-92">
          <Badge icon={<Truck className="w-4 h-4" data-id="element-94" />} text="ENVÍO GRATIS" data-id="element-93" />
          <Badge icon={<ShieldCheck className="w-4 h-4" data-id="element-96" />} text="180 DÍAS DE GARANTÍA" data-id="element-95" />
          <Badge icon={<CheckCircle className="w-4 h-4" data-id="element-98" />} text="APTO PRESERVATIVOS" data-id="element-97" />
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-4xl md:text-6xl lg:text-7xl font-black text-white tracking-tight mb-6 leading-[1.1]" data-id="element-99">
          Que dure más.
          <br data-id="element-100" />
          <span className="text-gold-500" data-id="element-101">Que se sienta más.</span>
        </motion.h1>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-400 max-w-2xl mb-10 leading-relaxed" data-id="element-102">
          Gel íntimo Gold con sensación estimulante para elevar la intensidad,
          disfrutar con más confianza y vivir relaciones más plenas.
        </motion.p>

        {/* CTA */}
        

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mt-16 w-full max-w-md relative" data-id="element-103">
          {/* Glow behind product */}
          <div className="absolute inset-0 bg-gold-500/10 rounded-full blur-[80px] scale-75" data-id="element-104" />

          <div className="relative" data-id="element-105">
            <img src="https://cdn.magicpatterns.com/uploads/p4NBvAzQcRQH21xffL3bsm/controlmax-product-ByFddxIV.png" alt="Gel Íntimo Gold Estimulante" className="w-full h-auto object-contain drop-shadow-[0_20px_60px_rgba(201,168,76,0.25)] relative z-10" data-id="element-106" />
          </div>
        </motion.div>
      </div>
    </section>;
}
function Badge({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex items-center gap-2 px-3 py-1.5 rounded-full border border-gold-500/30 bg-gold-500/5 text-gold-500 text-xs font-bold tracking-wider uppercase" data-id="element-107">
      {icon}
      <span data-id="element-108">{text}</span>
    </div>;
}